import React from "react";
import PropTypes from "prop-types";
import { FullWidthCard } from "@learningblocks/storybook-components";
import { Feedback } from "../../SharedComponents/Feedback";
import { SlideBlockContext } from "../../SlideBlock";
import "./style.scss";
/**
 * DroppedComponent :
 * Component the holds the dropped HexagonCard and Feedback
 */
export function DroppedNode(props) {
  const { getTabIndex } = React.useContext(SlideBlockContext);

  const onRemoveCard = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.onRemoveCard();
  };

  const wrapperClass = () =>
    ["fwCard-dropped", props.correct ? "fwCard-dropped__correct" : ""].join(
      " "
    );

  const renderFullWidthCard = () => (
    <FullWidthCard
      image={props.image}
      title={props.title}
      modal={props.modal}
      description={props.description}
      removeCard={props.correct ? null : onRemoveCard}
      tabIndex={getTabIndex()}
    />
  );

  const renderOverrideComponent = () =>
    React.cloneElement(props.overrides, {
      image: props.image,
      title: props.title,
      modal: props.modal,
      description: props.description,
      removeCard: !props.correct && onRemoveCard,
      tabIndex: getTabIndex(),
    });

  return (
    <div className={wrapperClass()}>
      {props.overrides ? renderOverrideComponent() : renderFullWidthCard()}
      <Feedback correct={props.correct} message={props.errorMessage} />
    </div>
  );
}

DroppedNode.propTypes = {
  /**
   * Specify if dropped component is correct
   */
  correct: PropTypes.bool.isRequired,
  /**
   * callback function to be executed when card needs to be removed from design section tree
   */
  onRemoveCard: PropTypes.func,
  /**
   * Url to the small card icon image
   */
  image: PropTypes.string.isRequired,
  /**
   * Title of the card
   */
  title: PropTypes.string.isRequired,
  /**
   * Data to be displayed in the modal
   */
  modal: PropTypes.object.isRequired,
  /**
   * Messgae to be displayed for error
   */
  errorMessage: PropTypes.string,
  /**
   * Override component that needs to rendered in case
   */
  overrides: PropTypes.object,
};

DroppedNode.defaultProps = {
  removeCard: undefined,
  image: "",
  title: "",
  errorMessage: "",
  overrides: undefined,
};
